import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import styled from 'styled-components';
import config from "../config";

const Container = styled.div`
  text-align: left;
`;

const Table = styled.table`
  margin: auto;
  border-spacing: 5px;
  text-align: center;
`;

const TableCell = styled.td`
  text-align: ${(props) => props.align || 'center'};
  padding: 5px 20px;
`;

const ButtonContainer = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: center;
  gap: 10px;
`;

const Button = styled.button`
  padding: 10px;
  font-size: 16px;
  cursor: pointer;
  border: none;
  background-color: #007bff;
  color: white;
  border-radius: 5px;
  &:hover {
    background-color: #0056b3;
  }
`;

const Verb = () => {
  const [verbs, setVerbs] = useState([]);
  const [page, setPage] = useState(0);
  const [totalVerbs, setTotalVerbs] = useState(null);
  const [selectedVerb, setSelectedVerb] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(false);
  const pageSize = 20;

  useEffect(() => {
    fetch(`${config.API_BASE_URL}/verbs/p-${page}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setVerbs(data);
        if (totalVerbs === null) {
          setTotalVerbs(data.length ? pageSize * (page + 1) : 0);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setLoadingError(true);
      });
  }, [page]);

  const fetchVerbDetails = (id) => {
    setLoading(true);
    setLoadingError(false);

    fetch(`${config.API_BASE_URL}/verbs/${id}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setSelectedVerb(data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setLoadingError(true);
      });
  };

  return (
    <Container>
     {selectedVerb ? (
        <div>
          <Link to="#" onClick={() => setSelectedVerb(null)} style={{ textDecoration: 'none' }}>powrót</Link>
          <h5>{selectedVerb.es} ({selectedVerb.pl})</h5>
          <Table>
            <tbody>
              <tr><TableCell>Bezokolicznik</TableCell><TableCell>{selectedVerb.es} ({selectedVerb.pl})</TableCell></tr>
              <tr><TableCell>Gerundio</TableCell><TableCell>{selectedVerb.gerundio}</TableCell></tr>
              <tr><TableCell>Participio</TableCell><TableCell>{selectedVerb.participio}</TableCell></tr>
            </tbody>
          </Table>
          <br/>
          <Table>
            <tbody>
              <tr>
                <TableCell>&nbsp;</TableCell>
                <TableCell><b>Indicativo Presente</b></TableCell>
                <TableCell><b>Indicativo Pretérito Imperfecto</b></TableCell>
              </tr>
              {selectedVerb.ind_pres.map((form, index) => (
                <tr key={index}>
                  <TableCell>{['(yo)', '(tú)', '(él/ella/Vd.)', '(nosotros/-as)', '(vosotros/-as)', '(ellos/-as/Vds.)'][index]}</TableCell>
                  <TableCell>{selectedVerb.ind_pres[index]}</TableCell>
                  <TableCell>{selectedVerb.ind_pret_imp[index]}</TableCell>
                </tr>
              ))}
            </tbody>
          </Table>
          <br/>
          <Table>
            <tbody>
              <tr>
                <TableCell>&nbsp;</TableCell>
                <TableCell><b>Indicativo Pretérito Indefinido</b></TableCell>
                <TableCell><b>Indicativo Futuro Imperfecto</b></TableCell>
              </tr>
              {selectedVerb.ind_pret_ind.map((form, index) => (
                <tr key={index}>
                  <TableCell>{['(yo)', '(tú)', '(él/ella/Vd.)', '(nosotros/-as)', '(vosotros/-as)', '(ellos/-as/Vds.)'][index]}</TableCell>
                  <TableCell>{selectedVerb.ind_pret_ind[index]}</TableCell>
                  <TableCell>{selectedVerb.ind_fut_imp[index]}</TableCell>
                </tr>
              ))}
            </tbody>
          </Table>
          <br/>
          <Table>
            <tbody>
              <tr>
                <TableCell>&nbsp;</TableCell>
                <TableCell><b>Subjuntivo Presente</b></TableCell>
                <TableCell><b>Subjuntivo Pretérito Imperfecto I</b></TableCell>
              </tr>
              {selectedVerb.sub_pres.map((form, index) => (
                <tr key={index}>
                  <TableCell>{['(yo)', '(tú)', '(él/ella/Vd.)', '(nosotros/-as)', '(vosotros/-as)', '(ellos/-as/Vds.)'][index]}</TableCell>
                  <TableCell>{selectedVerb.sub_pres[index]}</TableCell>
                  <TableCell>{selectedVerb.sub_pret_imp_i[index]}</TableCell>
                </tr>
              ))}
            </tbody>
          </Table>
          <br/>
          <Table>
            <tbody>
              <tr>
                <TableCell>&nbsp;</TableCell>
                <TableCell><b>Subjuntivo Pretérito Imperfecto II</b></TableCell>
                <TableCell><b>Condicional Simple</b></TableCell>
              </tr>
              {selectedVerb.sub_pret_imp_ii.map((form, index) => (
                <tr key={index}>
                  <TableCell>{['(yo)', '(tú)', '(él/ella/Vd.)', '(nosotros/-as)', '(vosotros/-as)', '(ellos/-as/Vds.)'][index]}</TableCell>
                  <TableCell>{selectedVerb.sub_pret_imp_ii[index]}</TableCell>
                  <TableCell>{selectedVerb.con_simple[index]}</TableCell>
                </tr>
              ))}
            </tbody>
          </Table>
          <br/>
        </div>
      ) : (
        <>
      <h5>Baza czasowników</h5>
      <p>ilość czasowników w bazie: 296</p>
      {loading ? (
          <p><b>Dane są ładowane ...</b></p>
        ) : loadingError ? (
          <p><b>Przepraszamy, wystąpił problem przy wczytywaniu</b></p>
        ) : (
          <>
          <ButtonContainer>
            {page > 0 && (
              <Button onClick={() => setPage(page - 1)}>&laquo; poprzednie 20</Button>
            )}
            {verbs.length === pageSize && (
              <Button onClick={() => setPage(page + 1)}>kolejne 20 &raquo;</Button>
            )}
          </ButtonContainer>
          <Table>
            <tbody>
              {verbs.map((verb) => (
                <tr key={verb.verb_id}>
                  <TableCell align="right">
                    <a href="#" onClick={() => fetchVerbDetails(verb.verb_id)}>{verb.verb_es}</a>
                  </TableCell>
                  <TableCell>{verb.verb_pl}</TableCell>
                </tr>
              ))}
            </tbody>
          </Table>
          </>
        )}
        </>
      )}
    </Container>
  );
};

export default Verb;